import { CommunityApp } from '@atlassian/learning-components';

export const getAppByRoute = (route: string) => {
  if (route === '/events') {
    return CommunityApp.EVENTS;
  }
  if (route === '/champions') {
    return CommunityApp.CHAMPIONS;
  }
  if (route.startsWith('/updates')) {
    return CommunityApp.HOME; // Updates route - use HOME since UPDATES enum doesn't exist
  }
  return CommunityApp.HOME;
};
